function init() {
    $("[data-specialist]").click(function() {
        $(".specialist").hide();
        $("." + $(this).data("specialist")).show();
    });
}

export default { init };
